import { ChangeDetectionStrategy, Component, ElementRef } from '@angular/core';

@Component({
  selector: 'x-swiper-slide',
  standalone: true,
  imports: [],
  templateUrl: './swiper-slide.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'swiper-slide' },
})
export class SwiperSlideComponent {
  constructor(public elementRef: ElementRef) {}
}
